import React from "react";

const RPS_LABELS = {
    1: "P",
    2: "R",
    3: "S"
};

const RpsResult = ({ resultData }) => {

    // Convert all result objects into one history array
    const resultHistory = (resultData || [])
        .map(item => Number(item.result))
        .filter(item => item > 0);

    // Split into rows of 10
    const rows = [];
    for (let i = 0; i < resultHistory.length; i += 10) {
        rows.push(resultHistory.slice(i, i + 10));
    }

    return (
        <div className="left-content">
            <div>
                <div className="cardAV">
                    <div className="card-headerAV">
                        Results for Last 50 Rounds
                    </div>
                    <div className="card-bodyAV">
                        {rows.map((row, rowIndex) => (
                            <div className="rowAV" key={rowIndex}>

                                {row.map((item, colIndex) => (
                                    <div className="colAV" key={colIndex}>
                                        <div className="result-itemAV border-normal">
                                            {RPS_LABELS[item] || "-"}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RpsResult;